import {
  customType,
  extend,
  params,
  string,
  bool,
  number,
  shape,
  arrayOf,
} from '@thd-nucleus/data-sources';
import { RetailMediaProductListingPod } from './RetailMediaProductListingPod';

export const dataModel = extend({
  plaModel: params({
    breadCrumbs: arrayOf(
      customType('BreadCrumbInput').shape({
        browseUrl: string(),
        label: string(),
      })
    ),
    categorySourceId: string(),
    channel: string(),
    customer: customType('Customer').shape({
      mcVisId: number(),
      customerType: string(),
      userId: string(),
      svocId: string(),
    }),
    debug: bool(),
    itemId: string(),
    itemIds: arrayOf(string()),
    keyword: string(),
    nValue: string(),
    schema: string(),
    storeId: string(),
    requestedAdCount: number(),
    zipCode: string(),
    plaLocation: string(),
    isBrandPage: bool(),
    adBlocker: string(),
    isBrandPricingPolicyCompliant: bool(),
  }).shape({
    products: arrayOf(shape(RetailMediaProductListingPod.dataModel.product)),
    sponsoredReport: shape({
      numberOfSponsoredProducts: number(),
      numberOfMissingProductInformationProducts: number(),
      numberOfNonAvailableProducts: number(),
    }),
  }),
});